import { createContext, createRef, useContext, type PropsWithChildren, type RefObject } from 'react'

// Module-level singleton: one <audio> element for the whole app, shared through context so the bar,
// the host and the playback hooks all address the same media element across soft navigation.
const audioRef = createRef<HTMLAudioElement>()

const AudioRefContext = createContext<RefObject<HTMLAudioElement | null>>(audioRef)

export const AudioRefProvider = ({ children }: PropsWithChildren) => (
    <AudioRefContext.Provider value={audioRef}>{children}</AudioRefContext.Provider>
)

export const useAudioRef = (): RefObject<HTMLAudioElement | null> => useContext(AudioRefContext)
